// Copyright (c) Docugami, Inc. All rights reserved.

import { chunkSelectedColor } from "components/shell/presentation/AppStyles";
import { Component, ComponentId } from "sdv/engine/Component";

export interface ColorComponent extends Component {
    typeId: ComponentId.Color
    color: string;
}

export const DefaultControlColorComponent: ColorComponent = {
    typeId: ComponentId.Color,
    color: chunkSelectedColor
}
